import { Box, TextBlock } from "@bcc-ui/ui-components";
import { t } from "i18next";
import React from "react";

import { ASSET_MANAGEMENT_ROUTE_BMP, OUR_IMPACT_DASHBOARD_ROUTE, WORKFLOWS_ROUTE } from "components/router/Routes";

interface AdvertisedRouteTooltipTranslationKeys {
    titleTranslationKey: string;
    bodyTranslationKey: string;
    footerTranslationKey: string;
}

const getAdvertisedRouteTooltipTranslationKeys = (route: string): AdvertisedRouteTooltipTranslationKeys | undefined => {
    switch (route) {
        case OUR_IMPACT_DASHBOARD_ROUTE.path:
            return {
                titleTranslationKey: "Routes.ourImpact.tooltip.unpaid.title",
                bodyTranslationKey: "Routes.ourImpact.tooltip.unpaid.calculate",
                footerTranslationKey: "Routes.ourImpact.tooltip.unpaid.contactBlancco",
            };
        case WORKFLOWS_ROUTE.path:
            return {
                titleTranslationKey: "Routes.workflowsMenu.unpaidTitle",
                bodyTranslationKey: "Routes.workflowsMenu.automateWorkflowsAndSimplifyCompliance",
                footerTranslationKey: "Routes.workflowsMenu.contactBlancco",
            };
        case ASSET_MANAGEMENT_ROUTE_BMP.path:
            return {
                titleTranslationKey: "Routes.assetManagement.unpaidTitle",
                bodyTranslationKey: "Routes.assetManagement.message",
                footerTranslationKey: "Routes.assetManagement.contactBlancco",
            };
        default:
            return undefined;
    }
};

export const getAdvertisedRouteTooltipContent = (route: string) => {
    const translationKeys = getAdvertisedRouteTooltipTranslationKeys(route);
    if (translationKeys == null) {
        return null;
    }

    return (
        <Box gap="Xxxs" columnLayout>
            <TextBlock disableBottomSpacing>
                <strong>{t(translationKeys.titleTranslationKey)}</strong>
            </TextBlock>
            <TextBlock disableBottomSpacing>{t(translationKeys.bodyTranslationKey)}</TextBlock>
            <TextBlock disableBottomSpacing>{t(translationKeys.footerTranslationKey)} </TextBlock>
        </Box>
    );
};
